import { IGetUser, ILoginPayload } from 'types/User';
import { baseAPI } from './baseAPI';

export const authAPI = baseAPI.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<
			ILoginPayload,
			{ identifier: string; password: string }
		>({
			query(body) {
				return {
					url: '/auth/local',
					method: 'POST',
					body,
				};
			},
		}),
		getUser: builder.mutation<IGetUser, string>({
			query(token) {
				return {
					url: '/users/me',
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				};
			},
		}),
	}),
});

export const { useLoginMutation, useGetUserMutation } = authAPI;
